import './dropdown.scss';
import $ from 'jquery';

$(document).ready(function () {
  $('.html-block:not(.author-mode)').each(function (i) {
    var elem = $(this);
    var shareElem = elem.find('.btn-mbic-share');
    var shareElemSmall = elem.find('.btn-mbic-share-small');

    // dropdown for big share button
    shareElem.one('click', function () {
      shareElem.addClass('dropdown-toggle').attr('id', 'dropdownMenuLink').attr('role', 'button').attr('data-toggle', 'dropdown').attr('aria-haspopup', 'true').attr('aria-expanded', 'true');
      shareElem.wrapAll('<div class="dropdown show"></div>');
      var dropdownMenu = $('<div class="dropdown-menu show" aria-labelledby="dropdownMenuLink">' +
        '<div class="row">' +
        '<div class="col-4">' +
          '<a class="dropdown-item" href="" data-analytics-linkcategory="share" data-analytics-linkname="share_button_facebook" data-analytics-linkposition="headline_and_copy"><i class="brandhub-icon-facebook"></i></a>' +
        '</div>' +
        '<div class="col-4">' +
          '<a class="dropdown-item" href="" data-analytics-linkcategory="share" data-analytics-linkname="share_button_twitter" data-analytics-linkposition="headline_and_copy"><i class="brandhub-icon-twitter"></i></a>' +
        '</div>' +
        '<div class="col-4">' +
          '<a class="dropdown-item" href="" data-analytics-linkcategory="share" data-analytics-linkname="share_button_email" data-analytics-linkposition="headline_and_copy"><i class="brandhub-icon-email"></i></a>' +
        '</div>' +
        '</div>' +
        '</div>');
      dropdownMenu.insertBefore(shareElem);
      $('.dropdown-toggle').dropdown('toggle');
    });

    // dropdown for small share button
    shareElemSmall.one('click', function () {
      shareElemSmall.addClass('dropdown-toggle').attr('id', 'dropdownMenuLink').attr('role', 'button').attr('data-toggle', 'dropdown').attr('aria-haspopup', 'true').attr('aria-expanded', 'true');
      shareElemSmall.wrapAll('<div class="dropdown show"></div>');
      var dropdownMenu = $('<div class="dropdown-menu dropdown-menu-small show" aria-labelledby="dropdownMenuLink">' +
        '<div class="row">' +
        '<div class="col-4">' +
        '<a class="dropdown-item" href="" data-analytics-linkcategory="share" data-analytics-linkname="share_button_facebook" data-analytics-linkposition="headline_and_copy"><i class="brandhub-icon-facebook"></i></a>' +
        '</div>' +
        '<div class="col-4">' +
        '<a class="dropdown-item" href="" data-analytics-linkcategory="share" data-analytics-linkname="share_button_twitter" data-analytics-linkposition="headline_and_copy"><i class="brandhub-icon-twitter"></i></a>' +
        '</div>' +
        '<div class="col-4">' +
        '<a class="dropdown-item" href="" data-analytics-linkcategory="share" data-analytics-linkname="share_button_email" data-analytics-linkposition="headline_and_copy"><i class="brandhub-icon-email"></i></a>' +
        '</div>' +
        '</div>' +
        '</div>');
      dropdownMenu.insertBefore(shareElemSmall);
      $('.dropdown-toggle').dropdown('toggle');
    });
    $('.dropdown').on('click', function () {
      $('.dropdown-toggle').dropdown('toggle');
    });
  });
});



// WEBPACK FOOTER //
// ./src/components/sharebuttondropdown/dropdown.js